/**
 * Handles mobile dropdown click behavior.
 * Prevents Bootstrap dropdown from closing when tapping
 * collapsible headers on mobile viewports.
 */
function initMobileDropdownBehavior() {
    const headers = document.querySelectorAll(".dropdown-header");

    headers.forEach(header => {
        header.addEventListener("click", (e) => {
            if (window.innerWidth < 992) {
                // Allow Bootstrap collapse to function, but stop the parent dropdown from closing
                e.stopPropagation();
            }
        });
    });
}


/**
 * Syncs chevron/icon state with Bootstrap collapse events.
 * Adds or removes the `is-open` class based on collapse visibility.
 */
function initCollapseIconState() {
    const collapses = document.querySelectorAll(".collapse");

    collapses.forEach(collapseEl => {

        collapseEl.addEventListener("show.bs.collapse", () => {
            const header = document.querySelector(
                `[data-bs-target="#${collapseEl.id}"]`
            );
            header?.classList.add("is-open");
        });

        collapseEl.addEventListener("hide.bs.collapse", () => {
            const header = document.querySelector(
                `[data-bs-target="#${collapseEl.id}"]`
            );
            header?.classList.remove("is-open");
        });

    });
}


/**
 * Initializes all menu-related functionality.
 */
export function initMenu() {
    initMobileDropdownBehavior();
    initCollapseIconState();
}